import { render, staticRenderFns } from "./NormalSearchNav372.vue?vue&type=template&id=55c70808&scoped=true"
import script from "./NormalSearchNav372.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav372.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c70808",
  null
  
)

export default component.exports